module.exports = __webpack_public_path__ + "static/media/background-googleMaps.8726a9d0.png";